module.exports = __webpack_public_path__ + "static/media/pdf_single_header.ff2c1c3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pdf_single_header.png
// module id = 457
// module chunks = 0